import React from "react";

import { Divider, Typography } from "@material-ui/core";

import AuthLayout from "../AuthLayout";
import SelectAccount from "modules/core/components/SelectAccount";

import { ILoginResponse } from "modules/auth/types/res";

interface ISelectAccountViewProps {
  accounts: ILoginResponse["accounts"];
  onSelect: (subdomain: string) => void;
}

const SelectAccountView: React.FC<ISelectAccountViewProps> = props => {
  const { accounts, onSelect } = props;

  return (
    <AuthLayout title="Choose Your Workspace">
      <Typography variant="body2" color="textSecondary">
        This email is associated to multiple workspaces. Choose the workspace
        you want to visit
      </Typography>

      <Divider variant="fullWidth" style={{ margin: "30px 0" }} />

      <SelectAccount accounts={accounts} onSelect={onSelect} />
    </AuthLayout>
  );
};

export default React.memo(SelectAccountView);
